import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpPerPixelFn} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/image-op-per-pixel-fn/node"
import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {createImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/convert-to-grayscale/definition"
import {HalCompositorInfo} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/image-op-per-pixel-fn/hal"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"

@registerNode
export class ImageOpNodeConvertToGrayscale extends ImageOpPerPixelFn<typeof definition> {
    static nodeClass = "ImageOpNodeConvertToGrayscale"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(parameters)
        this.listenToParameterChange("mode").subscribe(() => this.requestCompositorRebuild())
    }

    protected getCompositingInfo(): HalCompositorInfo {
        return {
            compositingFunction: `
                vec4 source = fetchSource(0);
                vec3 rgb = source.rgb;
                float value = ${this.parameters.mode === "luminance" ? "dot(rgb, vec3(0.2126, 0.7152, 0.0722))" : "(rgb.r + rgb.g + rgb.b) / 3.0"};
                return vec4(value);
                `,
            sourceParameterNames: ["sourceImage"],
            outDescriptor: {
                channels: 1,
            },
        }
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const evaluatedParameters = await evaluator.getAll(parameters)
        const descriptor = this.determineDescriptor(evaluatedParameters)
        return createImageOpImgProc(descriptor, {
            type: "toGrayscale",
            input: evaluatedParameters.sourceImage.node,
            mode: evaluatedParameters.mode,
        })
    }
}
